import { Button, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { UsuariosService } from "../../../services/api/Usuarios/UsuariosService";
import ModalSimNao from "../../../components/ModalSimNao";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilSquare, faPenToSquare, faPlusCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import PaginacaoLinks from "../../../components/Paginacao/PaginacaoLinks";
import Loading from "../../../components/Loader/Loading";
import ConfiguracoesSistemaPrincipal from "../ConfiguracoesSistemaPrincipal";
import { usePermissoes } from "../../../hooks/usePermissoes";
import PermissoesComponent from "../../../components/PermissaoComponent";


const Usuarios = () => {

    const [listaUsers, setListUsers] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [idDelete, setIdDelete] = useState(null)
    const [dadosPaginacao, setDadosPaginacao] = useState(null)
    const [page, setPage] = useState(null)
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 7, acoesId: 1 },
        { secoesId: 7, acoesId: 2 },
        { secoesId: 7, acoesId: 3 },
        { secoesId: 7, acoesId: 4 }
    ])

    const fetchUsers = async () => {
        setIsloading(true);
        const data = await UsuariosService.getAll(page)

        if (data.success) {
            setListUsers(data.data)
            setDadosPaginacao(data.meta)
        }
        setIsloading(false);
    }

    useEffect(() => {
        fetchUsers()
    }, [page])

    console.log(listaUsers)



    const handleDelete = (id) => {
        setIdDelete(id)
        setShowModal(true)
    }
    const handleClose = () => {
        setShowModal(false)
        setIdDelete(null)
    }
    const handleConfirmDelete = async () => {
        const usuario = await UsuariosService.deleteById(idDelete)
        handleClose();
        fetchUsers()
    }
    const onClickPage = (page) => {
        setPage(page)
    }





    return (
        <>
            <ConfiguracoesSistemaPrincipal>
                <h3>Usuários <Button className="ml-15" variant="success" size="sm" href="/admin/configuracoes/usuarios/cadEdit"> <FontAwesomeIcon icon={faPlusCircle}/> Novo Usuário</Button> </h3>
                <hr></hr>



                {(isLoading) ? <Loading /> : (
                    <>
                        {(!listPermissoes?.ver && !isLoadingPerm) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                            <>

                                {(listaUsers.length > 0) ?
                                    <>
                                        <Table bordered striped responsive size="sm">

                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>E-mail</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listaUsers.map((item, key) => (

                                                    <tr key={key}>
                                                        <td>{item.nome}</td>
                                                        <td>{item.email}</td>
                                                        <td className="text-center">
                                                            {(listPermissoes?.editar) ?
                                                                <Button variant="primary" size="sm" title="Editar" className="mr-10" href={'/admin/configuracoes/usuarios/cadEdit/' + item.id}><FontAwesomeIcon icon={faPenToSquare}  /> </Button>
                                                                : ''}
                                                                </td>
                                                                <td>
                                                            {(listPermissoes?.excluir) ?
                                                                <Button variant="danger" size="sm" title="Ecluir" onClick={() => handleDelete(item.id)}><FontAwesomeIcon icon={faTrash}  /></Button>
                                                                : ''}

                                                        </td>
                                                    </tr>

                                                ))}
                                            </tbody>

                                        </Table>

                                        <PaginacaoLinks totalPages={dadosPaginacao?.last_page}
                                            currentPage={dadosPaginacao?.current_page}
                                            onClickPage={onClickPage}
                                        ></PaginacaoLinks>

                                    </>

                                    : <div className="alert alert-warning text-center">Sem usuários registrados</div>}

                            </>)}
                    </>
                )}



                <ModalSimNao handleClose={handleClose} handleConfirm={handleConfirmDelete} show={showModal}>
                    Tem certeza que deseja excluir este usuário?
                </ModalSimNao>

            </ConfiguracoesSistemaPrincipal>

        </>
    )


}

export default Usuarios;